/**
 * Schema 1.4 - the letter a building carries on the client's printed tour sheet (A to K on Saier's), drawn the same
 * on its card, its line in the at-a-glance list and its map pin, so a partner holding the PDF and one on the page are
 * talking about the same space. The colour is the building's section colour, as on the map.
 */
export default function MapLetter({ letter, color }: { letter: string; color?: string }) {
  return (
    <span className="portal-map-letter" style={{ backgroundColor: color || undefined }} aria-label={`Map ${letter}`}>
      {letter}
    </span>
  );
}
